export default __webpack_public_path__ + "static/media/ninjatag_GLOWKA.80d25ab9.gif";